export const useLoading = () => {
  const loading = useState<boolean>('loading', () => false)

  const show = () => loading.value = true
  const hide = () => loading.value = false
  return {
    loading,
    show,
    hide
  }
}
